import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Building from '../../assets/SvgBuilding';
import Journey from '../../assets/SvgJourneyIcon';
import Contest from '../../assets/SvgContest';
import Daily from '../../assets/SvgDailyDoseIcon';
import { getSelectedLevelID, getMainTabID } from '../../redux/actions/DealershipActions';
import CustomGroups from '../../assets/CustomGroups';
import Rules from '../../assets/Rules';
import TopicOfTheMonth from '../../assets/TopicOfTheMonth';
import PXDashboardIcon from '../../assets/PXDashboardIcon';
import BookIcon from '../../assets/BookIcon';
import UsersIcon from '../../assets/UsersIcon';
import OpenBook from '../../assets/OpenBook';
import CertificationIcon from '../../assets/CertificationIcon';
import BrainIcon from '../../assets/BrainIcon';
import CategoriesIcon from '../../assets/CategoriesIcon';
import RnpIcon from '../../assets/RnpIcon';

const useStyle = makeStyles(() => ({
  card: {
    padding: '10px 12px 10px 10px',
    width: '121.5px',
    height: '65px',
    margin: '6px',
    bottom: '0%',
    background: '#FFFFFF',
    border: '2px solid #FAFAFA',
    boxSizing: 'border-box',
    cursor: 'pointer',
  },
  cardSelected: {
    padding: '10px 12px 10px 10px',
    width: '121.5px',
    height: '65px',
    margin: '6px',
    bottom: '0%',
    background: '#FFFFFF',
    boxSizing: 'border-box',
    cursor: 'pointer',
    border: '2px solid #622FEE',
  },
  icon: {
    width: '20px',
    height: '20px',
  },
  tabText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',
    color: 'rgba(0, 0, 0, 0.4)',
    opacity: '0.9',
  },
}));
const SideBarMenuTab = (props) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const levelIds = useSelector((state) => state.JourneyDetails.journeydetails.levels);
  const mainTabID = useSelector((state) => state.getMainTabID);
  const getTabType = () => {
    if (props.type === 'Journey') return 0;
    if (props.type === 'Dealerships') return 1;
    if (props.type === 'Stories') return 2;
    if (props.type === 'Plans') return 3;
    if (props.type === 'Report') return 4;
    if (props.type === 'Badges') return 7;
    if (props.type === 'Setup Auth') return 6;
    if (props.type === 'Collections') return 5;
    if (props.type === 'Leaderboard') return 8;
    if (props.type === 'Inapp') return 9;
    if (props.type === 'Custom Group') return 10;
    if (props.type === 'Rules') return 11;
    if (props.type === 'PX Dashboard') return 12;
    if (props.type === 'ToM') return 13;
    if (props.type === 'RockED Curriculum') return 14;
    if (props.type === 'RockED Fuel') return 15;
    if (props.type === 'Topics') return 16;
    if (props.type === 'Certifications') return 17;
    if (props.type === 'AI Roleplay') return 18;
    if (props.type === 'Categories') return 20;
    if (props.type === 'Contests') return 19;
    if (props.type === 'RNP') return 21;
    if (props.type === 'Quiz') return 22;
    if (props.type === 'Admin Users') return 23;
    return '';
  };
  const tabType = getTabType();
  const getIconSvg = () => {
    if (props.type === 'Dealerships' || props.type === 'Leaderboard' || props.type === 'Inapp')
      return <Building className={classes.icon} />;
    if (props.type === 'Journey') return <Journey className={classes.icon} />;
    if (
      props.type === 'Report' ||
      props.type === 'Badges' ||
      props.type === 'Contests' ||
      props.type === 'Collections' ||
      props.type === 'Quiz'
    )
      return <Contest className={classes.icon} />;
    if (props.type === 'Stories') return <Daily className={classes.icon} />;
    if (props.type === 'Plans') return <Building className={classes.icon} />;
    if (props.type === 'Custom Group') return <CustomGroups className={classes.icon} />;
    if (props.type === 'Rules') return <Rules className={classes.icon} />;
    if (props.type === 'ToM') return <TopicOfTheMonth className={classes.icon} />;
    if (props.type === 'PX Dashboard') return <PXDashboardIcon className={classes.icon} />;
    if (props.type === 'RockED Curriculum') return <BookIcon />;
    if (props.type === 'RockED Fuel') return <UsersIcon />;
    if (props.type === 'Topics') return <OpenBook />;
    if (props.type === 'Certifications') return <CertificationIcon />;
    if (props.type === 'AI Roleplay') return <BrainIcon />;
    if (props.type === 'Categories') return <CategoriesIcon />;
    if (props.type === 'RNP') return <RnpIcon />;
    if (props.type === 'Admin Users') return <UsersIcon />;
    return <Contest className={classes.icon} />;
  };
  const updateIds = (type) => {
    if (type === 'Journey') {
      dispatch(getMainTabID(0));
      if (levelIds[0] !== undefined) {
        dispatch(getSelectedLevelID(levelIds[0].id));
      }
    } else if (type === 'Dealerships') {
      dispatch(getMainTabID(1));

      if (levelIds[0] !== undefined) {
        dispatch(getSelectedLevelID(levelIds[0].id));
      }
    } else if (type === 'Stories') {
      dispatch(getMainTabID(2));

      if (levelIds[0] !== undefined) {
        dispatch(getSelectedLevelID(levelIds[0].id));
      }
    } else if (type === 'Plans') {
      dispatch(getMainTabID(3));
      if (levelIds[0] !== undefined) {
        dispatch(getSelectedLevelID(levelIds[0].id));
      }
    } else if (type === 'Report') {
      dispatch(getMainTabID(4));
    } else if (type === 'Badges') {
      dispatch(getMainTabID(7));
    } else if (type === 'Setup Auth') {
      dispatch(getMainTabID(6));
    } else if (type === 'Collections') {
      dispatch(getMainTabID(5));
    } else if (type === 'Leaderboard') {
      dispatch(getMainTabID(8));
    } else if (type === 'Inapp') {
      dispatch(getMainTabID(9));
    } else if (type === 'Custom Group') {
      dispatch(getMainTabID(10));
    } else if (type === 'Rules') {
      dispatch(getMainTabID(11));
    } else if (type === 'PX Dashboard') {
      dispatch(getMainTabID(12));
    } else if (type === 'ToM') {
      dispatch(getMainTabID(13));
    } else if (type === 'RockED Curriculum') {
      dispatch(getMainTabID(14));
    } else if (type === 'RockED Fuel') {
      dispatch(getMainTabID(15));
    } else if (type === 'Topics') {
      dispatch(getMainTabID(16));
    } else if (type === 'Certifications') {
      dispatch(getMainTabID(17));
    } else if (type === 'AI Roleplay') {
      dispatch(getMainTabID(18));
    } else if (type === 'Contests') {
      dispatch(getMainTabID(19));
    } else if (type === 'Categories') {
      dispatch(getMainTabID(20));
    } else if (type === 'RNP') {
      dispatch(getMainTabID(21));
    } else if (type === 'Quiz') {
      dispatch(getMainTabID(22));
    } else if (type === 'Admin Users') {
      dispatch(getMainTabID(23));
    }
  };
  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      className={mainTabID === tabType ? classes.cardSelected : classes.card}
      onClick={() => updateIds(props.type)}
      style={{ textAlign: 'center' }}
    >
      <Grid item style={{ width: '100%' }}>
        {getIconSvg()}
      </Grid>
      <Grid item>
        <Typography className={classes.tabText}> {props.type}</Typography>
      </Grid>
    </Grid>
  );
};

export default SideBarMenuTab;
